<div>
  <section class="shadow-sm bg-light p-3 mb-2 border rounded">
    <app-client-consult-note-task-options
      [task]="task"
      [formDisabled]="formDisabled"
      (taskChange)="onTaskChange($event)"
      />
  </section>
  @if (isYesSelected) {
    <section class="shadow-sm bg-light p-3 mb-2 border rounded">
      <h5 class="question mb-2">What is the date of the specialist encounter according to the consult note?</h5>
      <app-client-consult-note-task-dates
        [verifications]="verifications"
        [formDisabled]="formDisabled"
        [paging]="paging"
        (addVerification)="onAddVerification()"
        (updateVerification)="onUpdateVerification($event)"
        (removeVerification)="onRemoveVerification($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (pageChange)="onPageChange($event)"
        />
    </section>
  }
  <section class="mt-3 mb-2">
    <h5 class="prescriptions-header">
      Prescriptions for <strong class="phi">{{ task.patient.fullName }}</strong> from
      <strong>{{ task.provider.fullName }}</strong>
    </h5>
    <app-client-consult-note-task-prescriptions
      [task]="task"
      [prescriptions]="prescriptions"
      [formDisabled]="formDisabled"
      (addVerification)="onAddVerification()"
      (taskChange)="onTaskChange($event)"
      />
    @if (showPrescriptionsWarning) {
      <div class="alert alert-warning mt-1">
        One or more of the prescriptions listed was written on a different date than the one you provided. Add another
        consult note to qualify all prescriptions.
      </div>
    }
  </section>
  <app-client-consult-note-task-actions
    [task]="task"
    [formDisabled]="formDisabled"
    [prescriptions]="prescriptions"
    (taskChange)="onTaskChange($event)"
    />
</div>
<ng-template #spinner> <mat-spinner diameter="30" /> </ng-template>
